export default __webpack_public_path__ + "static/20-yard-dumpster-80e43410c5ffc85fad90e472a31eec9f.jpg";